export const BACKEND_BASE_URL = "https://api.cek-resi.net";
export const ALTCHA_ENABLED = true;
export const ALTCHA_CHALLENGE_URL = `${BACKEND_BASE_URL}/altcha/challenge`;
export const ISSO_ORIGIN = "https://komentar.cek-resi.net";
export const SITE_ORIGIN = "https://cek-resi.net";
export const ADSENSE_CLIENT_ID = "ca-pub-7703278859169278";
export const ADSENSE_ENABLED = true;
export const UMAMI_WEBSITE_ID =
  import.meta.env.VITE_UMAMI_WEBSITE_ID ||
  "8aa89b28-2986-4929-b898-209f540c700d";
export const UMAMI_SCRIPT_URL =
  import.meta.env.VITE_UMAMI_SCRIPT_URL || "https://stats.cek-resi.net/script.js";
export const UMAMI_DOMAINS =
  import.meta.env.VITE_UMAMI_DOMAINS || "cek-resi.net";
